import script from "./OutageSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./OutageSelect.vue?vue&type=script&lang=ts&setup=true"

import "./OutageSelect.vue?vue&type=style&index=0&id=60f9cce0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60f9cce0"]])

export default __exports__